import { h, Component } from 'preact'
import Header from '../header'
import ButtonControl from '../button-control'
import Icon from '../assets'

type Props = {
}

type State = {
}

export class Ideation extends Component<Props, State> {
  render () {
    return (
      <div className='group-overview-page'>
        <Header
          title='Ideation'
          disableSaveButton
          disableCancelButton
          customButtons={[
            <a href='/idea/overview' target='_blank'>
              <ButtonControl
                title={<div class='ideation-overview-link'>Go to ideation overview page<Icon icon={'openInNew'} width={16} height={16} /></div>}
                variant='secondary'
                newStyle
                size='medium'
              />
            </a>
          ]}
        />
      </div>
    )
  }
}

export default Ideation
